module.exports = __webpack_public_path__ + "img/logoblue.a114e82c.png";